module.exports = __webpack_public_path__ + "assets/img/fa7cd23790b60850acba363bed6193e7.png";